import { isNullOrUndefined } from '@app/util/util';
import { environment as ENV } from '@environment';

const LOCALE = ENV?.defaultLocale ?? null;
const KEY_SEPARATOR = '.';

export function staticSelectTranslate(key: string): string {
  const KEY_VALUE = key ?? '';
  const TRANSLATE = KEY_VALUE?.split(KEY_SEPARATOR).reduce(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (obj: any, prop: string) => obj?.[prop?.toUpperCase()] || obj?.[prop?.toLowerCase()],
    staticTranslateFile(LOCALE)
  );
  if (!isNullOrUndefined(TRANSLATE)) {
    return typeof TRANSLATE === 'string' ? TRANSLATE : KEY_VALUE;
  } else {
    return KEY_VALUE;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function staticTranslateFile(locale: string): any {
  switch (locale) {
    case ENV.available_locales.br:
      return require('@assets/i18n/pt-BR.json');
    case ENV.available_locales.co:
      return require('@assets/i18n/es-CO.json');
    case ENV.available_locales.mx:
      return require('@assets/i18n/es-MX.json');
    case ENV.available_locales.ar:
      return require('@assets/i18n/es-AR.json');
    case ENV.available_locales.pe:
      return require('@assets/i18n/es-PE.json');
    case ENV.available_locales.cl:
      return require('@assets/i18n/es-CL.json');
    case ENV.available_locales.uy:
      return require('@assets/i18n/es-UY.json');
    case ENV.available_locales.ec:
      return require('@assets/i18n/es-EC.json');
    default:
      return require('@assets/i18n/es-CO.json');
  }
}
